import { Content, Page, Header } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityListProvider,
  DefaultFilters,
} from '@backstage/plugin-catalog-react';
import { CatalogTable } from '@backstage/plugin-catalog';
import { makeStyles } from '@material-ui/core/styles';
import {
  getCompleteTableStyles,
} from '../styles/sharedStyles';

const useStyles = makeStyles(theme => ({
  contentFullWidth: {
    padding: theme.spacing(3, 5, 5, 5),
    minHeight: `calc(100vh - ${theme.spacing(25)}px)`,
    '& [class*="MuiGrid-grid-lg-10"]': {
      maxWidth: '100%',
      flexBasis: '100%',
      flex: '0 0 100%',
    },
    '& [class*="MuiGrid-grid-xs-12"]': {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  tableWrapper: {
    ...getCompleteTableStyles(theme),
  },
}));

export const CustomCatalogIndexPage = () => {
  const classes = useStyles();

  return (
    <Page themeId="home">
      <Header title="Software Catalog" />
      <Content className={classes.contentFullWidth}>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Content>
              <div className={classes.tableWrapper}>
                <CatalogTable />
              </div>
            </CatalogFilterLayout.Content>
            <div style={{ display: 'none' }}>
              <CatalogFilterLayout.Filters>
                <DefaultFilters />
              </CatalogFilterLayout.Filters>
            </div>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </Page>
  );
};
